import countryIsd from '@/countryIsd'

const countryList = countryIsd
	.map((country) => ({
		name: country.name,
		avatar: country.flag,
		isdCode: country.code.replace('+', ''),
		code: country.code.replace('+', '').replace(' ', '')
	}))
	.sort((a, b) => a.code - b.code)

export const findCountryByName = (name) => {
	if (typeof name !== 'string') return

	return countryList.find((c) => c.name.toLowerCase() === name.toLowerCase())
}

export default {
	isdCodeList() {
		return countryList
	}
}
